import { ofType } from 'redux-observable';
import { debounceTime, switchMap, mergeMap, catchError } from 'rxjs/operators';
import { from, of } from 'rxjs';
import {
  COMBINED_INVENTORY_SEARCH,
  COMBINED_INVENTORY_SUCCESS,
  EPIC_ERROR,
} from 'Constants/redux';
import service from 'Api/service';
import { fetchInventoryAvailability } from 'Actions/AvailabilityActions';
import { availabilityRequestBodyFromCombinedInventory } from '../helper_functions/availability';

const fetchCombinedInventoryEpic = (action$) =>
  action$.pipe(
    ofType(COMBINED_INVENTORY_SEARCH),
    debounceTime(500),
    switchMap((action) =>
      from(
        service.post(
          `${import.meta.env.VITE_API_DOMAIN}${action.link}`,
          action.options
        )
      ).pipe(
        mergeMap((response) => {
          const outActions = [
            {
              type: COMBINED_INVENTORY_SUCCESS,
              response,
              options: action.options,
              link: action.link,
              reset: true,
              productType: action.productType,
            },
          ];

          const { start_date, end_date } = action.options;
          if (start_date && end_date) {
            const serialized = response.data.inventories.filter(
              (i) => i.isSerialized
            );
            const notSerialized = response.data.inventories.filter(
              (i) => !i.isSerialized
            );

            const bodySerialized = availabilityRequestBodyFromCombinedInventory(
              serialized
            );
            const bodyNotSerialized = availabilityRequestBodyFromCombinedInventory(
              notSerialized
            );

            outActions.push(
              fetchInventoryAvailability({
                startDate: start_date,
                endDate: end_date,
                ...bodySerialized,
                rentalId: action.rentalId,
                rental_statuses: ['in_use', 'reservation'],
              }),
              fetchInventoryAvailability({
                startDate: start_date,
                endDate: end_date,
                ...bodyNotSerialized,
                rentalId: action.rentalId,
              })
            );
          }

          return outActions;
        }),
        catchError((error) => {
          console.error('fetchCombinedInventoryEpic error', error);
          return of({
            type: EPIC_ERROR,
            error,
          });
        })
      )
    )
  );

export default fetchCombinedInventoryEpic;
